(function () {
  'use strict';

  function breadcrumbFactory () {
    const factory = {};
    let breadcrumbs = [];

    function changeBreadcrumbs (stateArr) {
      breadcrumbs = stateArr;
    }

    function getBreadcrumbs () {
      return breadcrumbs;
    }

    function addItem (data, state) {
      breadcrumbs.push({
        state: state,
        label: data
      });
    }

    function getItem (item) {
      return item.label === this.label;
    }

    function checkItemIfExists (label) {
      return breadcrumbs.filter(getItem.bind({label: label})).length;
    }

    factory.changeBreadcrumbs = changeBreadcrumbs;
    factory.getBreadcrumbs = getBreadcrumbs;
    factory.addItem = addItem;
    factory.checkItemIfExists = checkItemIfExists;

    return factory;
  }

  angular.module('web2print.shared')
    .factory('breadcrumbFactory', breadcrumbFactory);

})();
